var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-container",
    { attrs: { fluid: "" } },
    [
      _c("admin-preloader", { attrs: { show: _vm.loading } }),
      _vm._v(" "),
      _c("admin-breadcrumb", {
        attrs: {
          items: [
            { text: "Shipping", path: { name: "admin-shipping" } },
            { text: "Shippers", path: { name: "admin-shippers" } },
          ],
          name: _vm.shipperName,
          "no-title": "",
        },
      }),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { lg: "4", md: "5" } },
            [
              _c(
                "admin-panel",
                {
                  attrs: { "second-body": "", "with-footer": "" },
                  scopedSlots: _vm._u([
                    {
                      key: "second-body",
                      fn: function () {
                        return [
                          _c("small", { staticClass: "text-muted" }, [
                            _vm._v("Created"),
                          ]),
                          _vm._v(" "),
                          _c("h6", [_vm._v(_vm._s(_vm.createdOn))]),
                          _vm._v(" "),
                          _c("small", { staticClass: "text-muted" }, [
                            _vm._v("Status"),
                          ]),
                          _vm._v(" "),
                          _c(
                            "p",
                            [
                              _vm.shipper.is_active
                                ? _c(
                                    "b-badge",
                                    { attrs: { variant: "success" } },
                                    [_vm._v("Active")]
                                  )
                                : _c(
                                    "b-badge",
                                    { attrs: { variant: "danger" } },
                                    [_vm._v("Inactive")]
                                  ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          !_vm.shipper.is_active
                            ? [
                                _c("small", { staticClass: "text-muted" }, [
                                  _vm._v("Deactivated"),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "h6",
                                  [
                                    _vm._v(
                                      "\n              on " +
                                        _vm._s(_vm.deactivatedOn) +
                                        "\n              "
                                    ),
                                    _vm.shipper.deactivated_by
                                      ? [
                                          _c("br"),
                                          _vm._v("by\n                "),
                                          _c(
                                            "b-link",
                                            {
                                              attrs: {
                                                to: {
                                                  name: "admin-user",
                                                  params: {
                                                    id: _vm.shipper.deactivated_by.id.toString(),
                                                  },
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm.shipper.deactivated_by
                                                      .name
                                                  ) +
                                                  "\n                "
                                              ),
                                            ]
                                          ),
                                        ]
                                      : _vm._e(),
                                  ],
                                  2
                                ),
                              ]
                            : _vm._e(),
                        ]
                      },
                      proxy: true,
                    },
                    {
                      key: "footer",
                      fn: function () {
                        return [
                          _c(
                            "div",
                            { staticClass: "text-center mt-n1" },
                            [
                              _c(
                                "no-permission-wrapper",
                                { attrs: { show: !_vm.canDeactivateShippers } },
                                [
                                  _vm.shipper.is_active
                                    ? _c(
                                        "b-btn",
                                        {
                                          staticClass: "mt-1",
                                          attrs: {
                                            variant: "danger",
                                            disabled:
                                              !_vm.canDeactivateShippers,
                                          },
                                          on: {
                                            click: function ($event) {
                                              $event.preventDefault()
                                              return _vm.deactivateShipper.apply(
                                                null,
                                                arguments
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v("Deactivate Shipper")]
                                      )
                                    : _c(
                                        "b-btn",
                                        {
                                          staticClass: "mt-1",
                                          attrs: {
                                            variant: "success",
                                            disabled:
                                              !_vm.canDeactivateShippers,
                                          },
                                          on: { click: _vm.activateShipper },
                                        },
                                        [_vm._v("Reactivate Shipper")]
                                      ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  _c(
                    "b-form",
                    {
                      on: {
                        submit: function ($event) {
                          $event.preventDefault()
                          return _vm.submitForm.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _c(
                        "b-form-group",
                        { attrs: { label: "Shipper Name" } },
                        [
                          _c("b-form-input", {
                            attrs: {
                              type: "text",
                              state: _vm.fieldValid("name"),
                              disabled: !_vm.canUpdateShippers,
                            },
                            model: {
                              value: _vm.formData.name,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.formData,
                                  "name",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "formData.name",
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "b-form-invalid-feedback",
                            { attrs: { state: _vm.fieldValid("name") } },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.formValidation.name) +
                                  "\n            "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-form-group",
                        { attrs: { label: "License Number" } },
                        [
                          _c("b-form-input", {
                            attrs: {
                              type: "text",
                              disabled: !_vm.canUpdateShippers,
                            },
                            model: {
                              value: _vm.formData.license_number,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.formData,
                                  "license_number",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "formData.license_number",
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "b-form-invalid-feedback",
                            {
                              attrs: {
                                state: _vm.fieldValid("license_number"),
                              },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.formValidation.license_number) +
                                  "\n            "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-form-group",
                        { attrs: { label: "Email Address" } },
                        [
                          _c("b-form-input", {
                            attrs: {
                              type: "text",
                              disabled: !_vm.canUpdateShippers,
                            },
                            model: {
                              value: _vm.formData.email,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.formData,
                                  "email",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "formData.email",
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "b-form-invalid-feedback",
                            { attrs: { state: _vm.fieldValid("email") } },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.formValidation.email) +
                                  "\n            "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-form-group",
                        { attrs: { label: "Phone Number" } },
                        [
                          _c("b-form-input", {
                            directives: [
                              {
                                name: "mask",
                                rawName: "v-mask",
                                value: "(###) ###-####",
                                expression: "'(###) ###-####'",
                              },
                            ],
                            attrs: {
                              type: "text",
                              placeholder: "(###) ###-####",
                              disabled: !_vm.canUpdateShippers,
                            },
                            model: {
                              value: _vm.formData.phone,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.formData,
                                  "phone",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "formData.phone",
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "b-form-invalid-feedback",
                            { attrs: { state: _vm.fieldValid("phone") } },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.formValidation.phone) +
                                  "\n            "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "text-center" },
                        [
                          _c(
                            "no-permission-wrapper",
                            { attrs: { show: !_vm.canUpdateShippers } },
                            [
                              _c(
                                "b-button",
                                {
                                  attrs: {
                                    type: "submit",
                                    variant: "primary",
                                    disabled:
                                      _vm.loading || !_vm.canUpdateShippers,
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                Update Shipper Info\n              "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { attrs: { lg: "8", md: "7" } },
            [
              _c(
                "admin-panel",
                {
                  attrs: {
                    title: "Shipper Prices",
                    "sub-title": "All prices added for this shipper",
                    "with-footer": "",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "header-right",
                      fn: function () {
                        return [
                          _c("b-form-select", {
                            staticClass: "w-auto mr-2",
                            attrs: { options: _vm.priceSortingOptions },
                            on: { change: () => _vm.loadPrices() },
                            model: {
                              value: _vm.prices.sorting,
                              callback: function ($$v) {
                                _vm.$set(_vm.prices, "sorting", $$v)
                              },
                              expression: "prices.sorting",
                            },
                          }),
                          _vm._v(" "),
                          _c("b-form-select", {
                            staticClass: "w-auto mr-2",
                            attrs: { options: _vm.stateOptions },
                            on: { change: () => _vm.loadPrices() },
                            model: {
                              value: _vm.prices.filters.destination_state,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.prices.filters,
                                  "destination_state",
                                  $$v
                                )
                              },
                              expression: "prices.filters.destination_state",
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "no-permission-wrapper",
                            { attrs: { show: !_vm.canUpdateShippers } },
                            [
                              _c(
                                "b-btn",
                                {
                                  staticClass: "mb-4",
                                  attrs: {
                                    variant: "success",
                                    disabled: !_vm.canUpdateShippers,
                                  },
                                  on: {
                                    click: function ($event) {
                                      $event.preventDefault()
                                      return _vm.openNewPriceModal.apply(
                                        null,
                                        arguments
                                      )
                                    },
                                  },
                                },
                                [_vm._v("Add New Price")]
                              ),
                            ],
                            1
                          ),
                        ]
                      },
                      proxy: true,
                    },
                    {
                      key: "footer",
                      fn: function () {
                        return [
                          _c("b-pagination", {
                            staticClass: "admin-pagination mb-0",
                            attrs: {
                              "total-rows": _vm.prices.total_in_pages,
                              "per-page": _vm.prices.per_page,
                              align: "center",
                            },
                            on: { change: _vm.loadPrices },
                            model: {
                              value: _vm.prices.page,
                              callback: function ($$v) {
                                _vm.$set(_vm.prices, "page", $$v)
                              },
                              expression: "prices.page",
                            },
                          }),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  _vm._v(" "),
                  _c(
                    "b-overlay",
                    { attrs: { show: _vm.prices.loading } },
                    [
                      _c("admin-shipper-prices-table", {
                        attrs: {
                          prices: _vm.prices.rows,
                          "no-shipper-col": "",
                        },
                        on: {
                          update: _vm.updatePrice,
                          delete: _vm.deletePrice,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("admin-shipper-price-new-modal", {
        ref: "newPriceModal",
        attrs: { "shipper-id": _vm.id },
        on: { created: _vm.newPriceCreated },
      }),
      _vm._v(" "),
      _c("admin-shipper-price-edit-modal", {
        ref: "editPriceModal",
        attrs: { "shipper-price": _vm.priceToEdit },
        on: { updated: _vm.priceUpdated },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }